const Visualizar = () => import('@/domains/notas_fiscais/auxiliares/naturezas_operacoes/views/Visualizar')
const Listar = () => import('@/domains/notas_fiscais/auxiliares/naturezas_operacoes/views/Listar')
const Editar = () => import('@/domains/notas_fiscais/auxiliares/naturezas_operacoes/views/Editar')
const Adicionar = () => import('@/domains/notas_fiscais/auxiliares/naturezas_operacoes/views/Adicionar')

const routes = [
    {
        name: 'listarNaturezasOperacoesEmissor',
        path: '/emissor/naturezas_operacoes',
        alias: ['/emissor/naturezas_operacoes/index'],
        component: Listar
    },
    {
        name: 'visualizarNaturezaOperacaoEmissor',        
        path: '/emissor/naturezas_operacoes/visualizar/:id',
        component: Visualizar
    },
    {
        name: 'adicionarNaturezaOperacaoEmissor', 
        path: '/emissor/naturezas_operacoes/adicionar',
        component: Adicionar
    },
    {
        name: 'editarNaturezaOperacaoEmissor',      
        path: '/emissor/naturezas_operacoes/editar/:id',
        component: Editar
    },
]

export default routes
